import Axios from "axios";
import config from "configs/config";
import getText from "Translator";

const returnError = (err, lang) => {
  console.log(err);
  const data = {
    success: false,
    code: 5001,
    message: getText("generalerror", lang),
  };
  return data;
};

export const getAllFilesForuser = async (datas, controller) => {
  try {
    let url = `${config.apiserver}/file/getallfilesforuser/`;
    let res = await Axios.post(url, datas, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};

export const getFilesWithNationalCode = async (datas, controller) => {
  try {
    let url = `${config.apiserver}/file/getFilesWithNationalCode/`;
    console.log(url);
    let res = await Axios.post(url, datas, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};

export const getShareFile = async (newData, controller) => {
  try {
    let url = config.apiserver + "/file/sharedpdf";

    // let newData = {
    //   capsule,
    //   forumGroup,
    //   file,
    //   result,
    //   lang: "fa",
    // };

    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};

export const deleteFiles = async (newData, controller) => {
  try {
    let url = config.apiserver + "/file/deletefiles/";

    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const copyFilesToNewClinic = async (newDate, controller) => {
  try {
    let url = config.apiserver + "/file/copyfilestonewclinic/";

    let res = await Axios.post(url, newDate, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};

export const setFileVisible = async (newDate, controller) => {
  try {
    let url = config.apiserver + "/file/setfilevisible/";

    let res = await Axios.post(url, newDate, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const getFileWithNationalCode = async (nationalCode, controller) => {
  try {
    let url =
      config.apiserver +
      "/file/getfilewithnationalcode/" +
      encodeURI(nationalCode);
    let res = await Axios.get(url, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};

export const getFileWithID = async (file, controller) => {
  try {
    let url = config.apiserver + "/file/getfilewithid/" + file;
    console.log(url);
    let res = await Axios.get(url, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};

export const getUsersFilesWithCapsule = async (newData, controller) => {
  try {
    let url = config.apiserver + "/file/getusersfileswithcapsule/";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const getFilesForuser = async (newData, controller) => {
  try {
    let url = config.apiserver + "/file/getfilesforuser/";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};

export const getPatientDetails = async (newData, controller) => {
  try {
    // { nationalCode,
    //   capsule,
    //   year,}
    let url = config.apiserver + "/file/getpatientdetails";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const StoreFile = async (newData, controller) => {
  try {
    let url = config.apiserver + "/file/storefile";
    let response = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return response.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const shareFile = async (newData, controller) => {
  try {
    let url = config.apiserver + "/file/sharedpdf/";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const updateFile = async (newData, controller) => {
  try {
    let url = config.apiserver + "/file/updatefile";
    let response = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return response.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};

export const uploadAttachFile = async (file, attachfile, text, controller) => {
  try {
    const datas = new FormData();
    datas.append("attachfile", attachfile);
    datas.append("file", file);
    datas.append("text", text);

    let url = config.apiserver + "/file/uploadattchedfile";
    let response = await Axios.post(url, datas, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return response.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const getAttachFile = async (newData, controller) => {
  try {
    let url = config.apiserver + "/file/getuploadfile";
    let response = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return response.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const removeUploadedFile = async (newData, controller) => {
  try {
    let url = config.apiserver + "/file/removeuploadedfile";
    let response = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return response.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};

//
export const addUserToFile = async (newData, controller) => {
  try {
    let url = config.apiserver + "/file/addusertofile/";
    // {
    //   nationalCode,
    //   capsule,
    // },
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};

export const getColleaguesFromServer = async (newData, controller) => {
  try {
    let url = config.apiserver + "/file/getcolleagues/";

    let response = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });

    return response.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};

export const storeFilesSugesstoin = async (newData, controller) => {
  try {
    let url = config.apiserver + "/file/storefilessugesstion/";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const sendFileColleaguesToServer = async (newData, controller) => {
  try {
    let url = config.apiserver + "/file/insertcolleagues/";

    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
